import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from "@/views/Login";
import {TokenService} from "@/services/token";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      isLogin: true
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/trips',
    name: 'Trips',
    component: () => import('@/views/Trips'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/trips-confirm',
    name: 'TripConfirm',
    component: () => import('@/views/TripsConfirm'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/trips-history',
    name: 'TripsHistory',
    component: () => import('@/views/TripsHistory'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/trips-select',
    name: 'TripsSelect',
    component: () => import('@/views/TripsSelect'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/drivers',
    name: 'Drivers',
    component: () => import('@/views/Drivers'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/fleet',
    name: 'Fleet',
    component: () => import('@/views/Fleet'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: () => import('@/views/Invoice'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/contracts',
    name: 'Contracts',
    component: () => import('@/views/Contracts'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/logos',
    name: 'Logos',
    component: () => import('@/views/Logos'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/links',
    name: 'Links',
    component: () => import('@/views/Links'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/time-schedule',
    name: 'TimeSchedule',
    component: () => import('@/views/TimeSchedule'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/repairs',
    name: 'Repairs',
    component: () => import('@/views/Repairs'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/worktime',
    name: 'Worktime',
    component: () => import('@/views/Worktime'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/leave-requests',
    name: 'LeaveRequests',
    component: () => import('@/views/LeaveRequests'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    component: () => import('@/views/Documents'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/fms',
    name: 'FMS',
    component: () => import('@/views/Fms'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/extra-hours',
    name: 'ExtraHours',
    component: () => import('@/views/ExtraHours'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/behaviour',
    name: 'Behaviour',
    component: () => import('@/views/Behaviour'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('@/views/Feedback'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path:'/*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next) => {
  const loggedIn = !!TokenService.getUser();
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(!loggedIn){
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      });
    }else{
      next();
    }
  }
  else if(to.matched.some(record => record.meta.isLogin)){
    if(!loggedIn){
      next();
    }
    else{
      next({
        path: '/'
      });
    }
  }
  else{
    next();
  }
});

export default router
